import { Box, Divider, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import bankAccountInfoImg from "../../../../../../media/images/icons/BankAccountInfo.svg";
import ArrowDownSVG from "../../../../../../media/images/icons/arrow-down";
import DangerFill from "../../../../../../media/images/icons/danger-fill";
import CustomButton from "../../../../../components/CustomButton";
import CustomInputLabel from "../../../../../components/CustomInputLabel";
import CustomInput from "../../../../../components/CustomInput";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/useRedux";
import useSWRMutation from "swr/mutation";
import { useFormik } from "formik";
import { fetcherPost } from "../../../../../../services/fetcher";
import CustomSelectOption from "../../../../../components/CustomSelectOption";

import {
  setDialogStatus,
  setDialogTitle,
  setOpenDialog,
} from "../../../../../../redux/features/dialogSlice";
import { setBankAccountInfo } from "../../../../../../redux/features/ownerSlice";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../../redux/features/snackbarSlice";

export default function BankAccountInfo() {
  const [isOpen, setIsOpen] = useState(false);

  const theme = useTheme();

  const dispatch = useAppDispatch();
  const { bankAccountInfo } = useAppSelector((state) => state.owner);

  const toggleBox = () => {
    setIsOpen(!isOpen);
  };
  const banksList = [
    "بانک اقتصاد نوین",
    "بانک انصار",
    "بانک ایران زمین",
    "بانک پارسیان",
    "بانک پاسارگاد",
    "بانک تجارت",
    "بانک توسعه تعاون",
    "بانک توسعه صادرات ایران",
    "بانک حکمت ایرانیان",
    "بانک خاور میانه",
    "بانک دی",
    "بانک رفاه",
    "بانک سامان",
    "بانک سپه",
    "بانک سرمایه",
    "بانک سینا",
    "بانک شهر",
    "بانک صادرات",
    "بانک صنعت و معدن",
    "بانک قرض‌الحسنه رسالت",
    "بانک قرض‌الحسنه مهر ایران",
    "بانک قوامین",
    "بانک کارآفرین",
    "بانک کشاورزی",
    "بانک گردشگری",
    "بانک مسکن",
    "بانک ملت",
    "بانک ملی ایران",
    "پست بانک ایران",
  ];

  const bankAccountInfoFormik = useFormik({
    initialValues: {
      shNr: bankAccountInfo?.shNr,
      AccountNr: bankAccountInfo?.accountNr,
      CardNr: bankAccountInfo?.cardNr,
      bankName: bankAccountInfo?.cardNr,
    },
    onSubmit: (values) => {
      postBankAccountInfo(values);
    },
  });

  const {
    trigger: postBankAccountInfo,
    isMutating: isPostBankAccountInfoMutating,
  } = useSWRMutation(
    [
      `/Account/OwnerSetAccountInfo
`,
      localStorage.getItem("access_token"),
    ],

    fetcherPost,
    {
      onSuccess: () => {
        dispatch(setOpenDialog(true));
        dispatch(setDialogStatus("success"));
        dispatch(setDialogTitle("ثبت اطلاعات با موفقیت انجام شد!"));

        dispatch(
          setBankAccountInfo({
            accountNr: bankAccountInfoFormik.values.AccountNr,
            cardNr: bankAccountInfoFormik.values.CardNr,
            shNr: bankAccountInfoFormik.values.shNr,
            bankName: bankAccountInfoFormik.values.bankName,
          })
        );
      },
    }
  );

  useEffect(() => {
    bankAccountInfoFormik.setValues({
      AccountNr: bankAccountInfo?.accountNr,
      CardNr: bankAccountInfo?.cardNr,
      shNr: bankAccountInfo?.shNr,
      bankName: bankAccountInfo?.bankName,
    });
  }, [bankAccountInfo]);

  const handleSelectOption = (value: any, type: string) => {
    switch (type) {
      case "bankName":
        bankAccountInfoFormik.setFieldValue("bankName", banksList[value - 2]);
        break;

      default:
        break;
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.bgColor.white,
        display: "flex",
        flexDirection: "column",
        border: "1px solid",
        borderColor: theme.palette.bgColor.blueGrey100,
        borderRadius: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "start",
          justifyContent: "space-between",
          padding: "8px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "start",
            gap: "4px",
          }}
        >
          <img width={32} src={bankAccountInfoImg} alt="" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography
              sx={{
                color: "primary.main",
                fontWeight: "700",
                fontSize: "16px",
              }}
            >
              حساب بانکی
            </Typography>
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: "700",
              }}
            >
              شماره شبا، شماره حساب، شماره کارت
            </Typography>
          </Box>
        </Box>
        <CustomButton
          justifyContent="space-between"
          onClick={() => toggleBox()}
          bgColor={isOpen ? "error.light" : theme.palette.secondary[50]}
          title={isOpen ? "بستن جزئیات" : "  مشاهده/ویرایش"}
          fSize="12px"
          fWeight="600"
          rippleColor={
            isOpen ? theme.palette.error.main : theme.palette.secondary.main
          }
          borderColor={isOpen ? "error.main" : "secondary.main"}
          py="10px"
          px="6px"
          gap="4px"
          borderRadius="8px"
          textColor={isOpen ? "error.main" : "secondary.main"}
          icon2={
            <Box
              sx={{
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.3s",
              }}
            >
              <ArrowDownSVG
                size={14}
                color={
                  isOpen
                    ? theme.palette.error.main
                    : theme.palette.secondary.main
                }
              />
            </Box>
          }
        />
      </Box>
      <Box
        sx={{
          overflow: "hidden",
          maxHeight: isOpen ? "1000px" : 0,
          transition: isOpen ? "max-height 0.5s ease" : "max-height 0.2s ease",
          paddingX: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        <Divider variant="fullWidth" />
        <Box
          sx={{
            backgroundColor: theme.palette.primary[50],
            borderRadius: "8px",
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <DangerFill color={theme.palette.primary.main} />
            <Typography
              sx={{
                color: "primary.main",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              توجه:
            </Typography>
          </Box>
          <Typography
            sx={{
              color: "primary.main",
              fontSize: "12px",
              textAlign: "justify",
            }}
          >
            نام حساب بانکی باید با مشخصات هویتی شما برابر باشد.
          </Typography>
        </Box>
        <Box
          sx={{
            flex: "1",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            // border: "1px solid gray",
          }}
        >
          <Box>
            <CustomInputLabel required>{"شماره شبا"}</CustomInputLabel>
            {/* <IBanNumberInput /> */}
            <CustomInput
              name="shNr"
              value={bankAccountInfoFormik.values.shNr}
              handelChange={bankAccountInfoFormik.handleChange}
              // handelChange={(e) => {
              //   if (e.target.value.length > 10) return;
              //   PreventInputAlpha(e, accomodationFormik.handleChange);
              // }}
              placHolder="شماره شبا خودرا وارد کنید..."
              endAdornment={
                <Typography
                  sx={{
                    color: "primary.main",
                    fontWeight: "700",
                  }}
                >
                  IR
                </Typography>
              }
            />
          </Box>
          <Box>
            <CustomInputLabel>{"شماره حساب"}</CustomInputLabel>
            <CustomInput
              name="AccountNr"
              value={bankAccountInfoFormik.values.AccountNr}
              handelChange={bankAccountInfoFormik.handleChange}
              placHolder="شماره حساب را وارد کنید..."
            />
          </Box>
          <Box>
            <CustomInputLabel>{"شماره کارت"}</CustomInputLabel>
            <CustomInput
              name="CardNr"
              value={bankAccountInfoFormik.values.CardNr}
              handelChange={bankAccountInfoFormik.handleChange}
              placHolder="شماره کارت را وارد کنید..."
            />{" "}
          </Box>
          <Box>
            <CustomInputLabel>{"نام بانک"}</CustomInputLabel>
            <CustomSelectOption
              type="bankName"
              setValue={handleSelectOption}
              height="40px"
              value={
                bankAccountInfoFormik.values.bankName
                  ? (
                      banksList.indexOf(bankAccountInfoFormik.values.bankName) +
                      2
                    ).toString()
                  : "1"
              }
              // error={companyActivity.error}
              // errorMessage={companyActivity.errorMessage}
              options={[
                {
                  value: 1,
                  label: "نام بانک را انتخاب کنید",
                  disabled: true,
                },
                ...banksList.map((item, index) => ({
                  label: item,
                  value: index + 2,
                })),
              ]}
            />
          </Box>
          <Box
            sx={{
              gap: "8px",
              display: "flex",
              alignItems: "center",
              mb: 2,
            }}
          >
            <CustomButton
              flex={1}
              justifyContent="center"
              onClick={() => toggleBox()}
              bgColor={theme.palette.primary[50]}
              title={"انصراف"}
              fSize="16px"
              fWeight="700"
              borderColor={theme.palette.primary.main}
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={theme.palette.primary.main}
            />
            <CustomButton
              loading={isPostBankAccountInfoMutating}
              flex={1}
              justifyContent="center"
              onClick={() => {
                bankAccountInfoFormik.handleSubmit();
              }}
              bgColor={"primary.main"}
              title={"ذخیره اطلاعات"}
              fSize="16px"
              fWeight="700"
              py="10px"
              px="6px"
              gap="4px"
              borderRadius="6px"
              textColor={"#fff"}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
